import { render, staticRenderFns } from "./InviteParticipant.vue?vue&type=template&id=37cd3caf&"
import script from "./InviteParticipant.vue?vue&type=script&lang=js&"
export * from "./InviteParticipant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports